import type { FallbackProps } from '@gik/core/api/BaseAPIConfig';
import { withTitle } from '@gik/core/hocs/withTitle';
import routes from '@gik/core/routes';
import type { IHomePageProps } from '@gik/landing-pages/pages/HomePage';
import { HomePage } from '@gik/landing-pages/pages/HomePage';
import { UI } from '@gik/ui-legacy/UIManager';
import { LightboxMedia } from '@gik/ui-legacy/UIManager/UILightboxTypes';
import type { PageLayoutProps } from '@/components/layout/PageLayout';
import { PageLayout } from '@/components/layout/PageLayout';
import { SWRConfig } from 'swr';

export default function HomepageComp({ fallback }: FallbackProps<IHomePageProps>) {
  return withTitle(
    'Give InKind',
    <SWRConfig value={{ fallback }}>
      <HomePage {...homepageProps} />
    </SWRConfig>
  );
}

HomepageComp.getLayout = function getLayout(page, layoutProps: PageLayoutProps) {
  return (
    <PageLayout {...layoutProps} key={layoutProps.key}>
      {page}
    </PageLayout>
  );
};

const homepageProps: IHomePageProps = {
  ctaSection: {
    ctas: [
      {
        title: 'How Give InKind Works',
        content:
          'Learn why Give InKind is the easiest way to coordinate meaningful support through meal trains, gift cards, volunteer signups, and more—all in one place.',
        icon: `/homepage/img/header/how-gik-works.png`,
        linkIcon: true,
        onClickIcon: () => {
          UI.lightbox(
            [
              {
                url: 'https://www.youtube.com/watch?v=Z7TpGaI67rI',
                mediaType: LightboxMedia.VIDEO,
                videoProps: {
                  autoPlay: true,
                },
              },
            ],
            {
              title: 'How it Works',
            }
          );

          return false;
        },
        buttonTitle: 'Learn More',
        buttonLink: routes.howItWork,
      },
      {
        title: 'Flexible and secure gifting',
        content:
          'Give InKind is the only website where recipients have 100% choice over how and where to use their gift. Our integrated, trackable gift cards mean no more lost or unused gifts.',
        icon: `/homepage/img/header/flexible-secure-gifting.png`,
        buttonTitle: 'Read More',
        buttonLink: routes.organizeGiftCard,
      },
      {
        title: 'Free for Groups, too',
        content:
          'Whether you need to organize support for one person or one hundred, we are ready to help. Perfect for faith groups, HR, schools and more. Get started today!',
        icon: `/homepage/img/header/free-for-groups.png`,
        buttonTitle: 'Read More',
        buttonLink: routes.forGroups,
      },
    ],
  },
};
